/* eslint-disable camelcase */
import React, { useState } from "react"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from "@mui/material"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import SaveIcon from "@mui/icons-material/Save"
import { api, showSuccess, showWarning } from "../../../api"

const ModalTareaBasica = ({ open, onClose, etapa, car_id }) => {
  const [observacion, setObservacion] = useState("")
  const queryClient = useQueryClient()

  const { mutateAsync: registrarTarea, isPending } = useMutation({
    mutationFn: async () => {
      return await api.post("/CRM_Carpetas/registrarTareaManual", {
        car_id,
        eta_id: etapa.eta_id,
        observacion,
      })
    },
    onSuccess: (res) => {
      showSuccess(res?.data?.data || "Tarea guardada correctamente.")
      queryClient.invalidateQueries(["getCarpetaWorkspace"])
      onClose()
    },
    onError: (err) => {
      showWarning(err?.response?.data?.message || "Error al registrar la tarea.")
    },
  })

  const handleGuardar = async () => {
    if (etapa.eta_requiere_obs && !observacion.trim()) {
      showWarning("Esta etapa exige que escribas una observación.")
      return
    }
    await registrarTarea()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: "#f5f5f5", color: "primary.main", fontWeight: "bold" }}>
        Registrar Acción Manual
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Etapa a completar:
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {etapa.eta_nombre}
          </Typography>
        </Box>

        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          label="Observación / Resultado de la gestión"
          variant="outlined"
          value={observacion}
          onChange={(e) => setObservacion(e.target.value)}
          required={etapa.eta_requiere_obs}
          placeholder="Ej. El cliente no contesta. Dejé mensaje en WhatsApp..."
          helperText={etapa.eta_requiere_obs ? "* Obligatorio para avanzar" : "Opcional"}
        />
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={isPending}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
          onClick={handleGuardar}
          disabled={isPending}
          sx={{ fontWeight: "bold" }}
        >
          Guardar y Avanzar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalTareaBasica
